// Via shuttle service area polygon data
// Source: https://www.google.com/maps/d/u/0/viewer?mid=1YL0V0Uq2m63mcwaWoyS-V7Yn1PaMo4I
// Coordinates in [lat, lng] format for Leaflet

export const viaServiceAreaEastern = [
  [41.8084887, -87.6066507],
  [41.7858851, -87.6061249],
  [41.7858451, -87.608571],
  [41.7836931, -87.6084852],
  [41.7837091, -87.6060928],
  [41.7785728, -87.6059533],
  [41.7788609, -87.5747538],
  [41.7792889, -87.5745928],
  [41.7795569, -87.5741315],
  [41.7796812, -87.5735804],
  [41.7798375, -87.5729863],
  [41.780278, -87.572914],
  [41.7807751, -87.5713103],
  [41.7815451, -87.5683173],
  [41.7845572, -87.5676527],
  [41.7819091, -87.5683407],
  [41.781701, -87.5689012],
  [41.782149, -87.5716961],
  [41.7826011, -87.5729621],
  [41.7834531, -87.5744856],
  [41.7841691, -87.5756282],
  [41.7850771, -87.5766635],
  [41.7867091, -87.5775219],
  [41.788133, -87.5774468],
  [41.788637, -87.5772751],
  [41.789181, -87.5779296],
  [41.7897649, -87.5783802],
  [41.7906128, -87.5791741],
  [41.7914448, -87.5797213],
  [41.7919727, -87.5796355],
  [41.7920767, -87.5797213],
  [41.7925406, -87.5793994],
  [41.7938925, -87.5792063],
  [41.7946843, -87.5788737],
  [41.7954762, -87.5785948],
  [41.796548, -87.5782622],
  [41.7972599, -87.5792814],
  [41.7980597, -87.5804187],
  [41.801243, -87.5809766],
  [41.8023307, -87.5809551],
  [41.8041862, -87.5815666],
  [41.8051698, -87.5827039],
  [41.8072971, -87.5855041],
  [41.8094963, -87.587092],
  [41.8097842, -87.587328],
  [41.8091284, -87.5895274],
  [41.8087326, -87.5912708],
  [41.8086946, -87.5931189],
  [41.8086406, -87.5951171],
  [41.8084887, -87.6066507],
];

export const viaServiceAreaWestern = [
  [41.7964878, -87.6159537],
  [41.7961839, -87.6324439],
  [41.7961919, -87.6328623],
  [41.7937923, -87.6328087],
  [41.7940722, -87.6158785],
  [41.7964878, -87.6159537],
];

export const uchicagoMainCampus = [
  [41.7963616, -87.6063773],
  [41.7844666, -87.606152],
  [41.7844906, -87.6052293],
  [41.7840426, -87.6052293],
  [41.7841626, -87.5930521],
  [41.7846986, -87.5930306],
  [41.7846986, -87.5915071],
  [41.7841466, -87.5914857],
  [41.7843146, -87.5908205],
  [41.7845306, -87.590284],
  [41.7835226, -87.5902626],
  [41.7835306, -87.5899514],
  [41.7882345, -87.5890073],
  [41.7882425, -87.5901446],
  [41.7889625, -87.5902089],
  [41.7889705, -87.5913784],
  [41.7889625, -87.5914535],
  [41.7896824, -87.5914964],
  [41.7896584, -87.595391],
  [41.7914343, -87.5954124],
  [41.7914343, -87.5980946],
  [41.7951138, -87.5981697],
  [41.7951218, -87.6038453],
  [41.7957377, -87.6038775],
  [41.7957457, -87.6044568],
  [41.7963936, -87.6045105],
  [41.7963616, -87.6063773],
];

export const viaZoneStyle = {
  serviceArea: {
    color: '#e74c3c',
    weight: 2,
    opacity: 0.7,
    fillColor: '#e74c3c',
    fillOpacity: 0.08,
    dashArray: '6, 4',
    interactive: false,
  },
  campus: {
    color: '#8B0000',
    weight: 2,
    opacity: 0.8,
    fillColor: '#8B0000',
    fillOpacity: 0.12,
    interactive: false,
  },
};
